module.exports = __webpack_public_path__ + "img/baac.f29ce2ee.png";